const shouldReturn = (...args) => !!args.filter(Boolean).length;
export default shouldReturn;
//# sourceMappingURL=should-return.js.map